import { createApi } from '@reduxjs/toolkit/query/react';
import createBaseQuery from '../../utils/baseQuery';

const baseQueryWithReAuth = createBaseQuery('user');

export const contactUsApiSlice = createApi({
  reducerPath: 'contactUsApi',
  baseQuery: baseQueryWithReAuth,
  endpoints: (builder) => ({
    sendContactUsMessage: builder.mutation({
      query: (payload) => ({
        url: 'contact-us',
        method: 'POST',
        body: payload
      })
    })
  })
});

export const { useSendContactUsMessageMutation } = contactUsApiSlice;
